export default __webpack_public_path__ + "static/media/step2-resp.fabf0e13.png";